import { configureStore } from '@reduxjs/toolkit'

import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { combineReducers } from '@reduxjs/toolkit'
import boardSlice from './slice/board-slice'
import columnSlice from './slice/column-slice'
import cardSlice from './slice/card-slice'
import authSlice from './slice/auth-slice'
import homeCardSlice from './slice/home-card-slice'
import lastUpdateSlice from './slice/last-update-slice'
import otherBoardSlice from './slice/other-board-slice'
import ColumnPositionSlice from './slice/column-positions'
import BoardDesignSlice from './slice/board-design'
import archivedBoardSlice from './slice/archived-board'
import inviteSlice from './slice/invitation-accepted-slice'
import isRenderSlice from './slice/isRender-slice'
import allBoardsSlice from './slice/all-boards-slice'
import subscriptionSlice from './slice/subscription-slice'
import DoneFilterSlice from './slice/DoneFilter'
import paymentSlice from './slice/payment-slice'
import RedirectionSlice from './slice/redirect-slice'
import aiSlice from './slice/ai-slice'
import TotalLicenseSlice from './slice/total-license-slice'
import companyDetailSlice from './slice/company-details-slice'
import contactDetailSlice from './slice/contact-detail-slice'
import roleSlice from './slice/role-slice'
import homeSearchingSlice from './slice/home-searching-slice'
import organizationInvitationSlice from './slice/organization-accepted'
import { EncryptTransform } from "../../app/utils/reduxEncrypt"
import boardTagsSlice from './slice/board-tags-slice'
import homeTagsSlice from './slice/home-tags-slice'
import selectedTagsSlice from './slice/selected-tags'
import pageSlice from './slice/page-slice'
import tourSlice from './slice/tour-slice'
import integrationSlice from './slice/integration-slice'
// import  from 'redux-persist-transform-encrypt';


// Use env secret or fallback so encrypt never gets undefined (set REACT_APP_PERSIST_SECRET in .env)
const persistSecret = process.env.REACT_APP_PERSIST_SECRET || 'dev-persist-secret-key';

const encryptor: any = EncryptTransform({
  secretKey: persistSecret,
  onError: function (error: any) {
    // eslint-disable-next-line no-console
    console.error('Redux Persist Encryptor Error:', error);
  },
});


const persistConfig = {
  key: 'root',
  storage,
  transforms: [encryptor]
};


const reducers = combineReducers({
  boardTagsReducer: boardTagsSlice,
  homeTagsReducer: homeTagsSlice,
  selectedTagsReducer: selectedTagsSlice,
  boardReducer: boardSlice,
  columnReducer: columnSlice,
  cardReducer: cardSlice,
  pageReducer: pageSlice,
  authReducer: authSlice,
  homeCardReducer: homeCardSlice,
  lastUpdateReducer: lastUpdateSlice,
  inviteReducer: inviteSlice,
  isRenderReducer: isRenderSlice,
  tourSliceReducer: tourSlice,
  allBoardsReducer: allBoardsSlice,
  otherBoardReducer: otherBoardSlice,
  archivedBoardReducer: archivedBoardSlice,
  ColumnPositionReducer: ColumnPositionSlice,
  boardDesignReducer: BoardDesignSlice,
  subscriptionReducer: subscriptionSlice,
  DoneFilterReducer: DoneFilterSlice,
  paymentReducer: paymentSlice,
  RedirectionReducer: RedirectionSlice,
  aiReducer: aiSlice,
  TotalLicenseReducer: TotalLicenseSlice,
  PersonRoleReducer: roleSlice,
  // SwitchAccountReducer: SwitchAccountSlice,
  contactDetailReducer: contactDetailSlice,
  companyDetailReducer: companyDetailSlice,
  organizationInvitationReducer: organizationInvitationSlice,
  homeSearchingReducer: homeSearchingSlice,
  integrationReducer: integrationSlice,
})

const persistedReducer = persistReducer(persistConfig, reducers)



export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.REACT_APP_ENVIRONMENT === 'development',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

// Infer the `RootState` and `AppDispatch` types from the store itself
// export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
// export type AppDispatch = typeof store.dispatch
// export const useAppDispatch = () => useDispatch<AppDispatch>()
